import { USER_TYPES } from "helpers/sf_constants"

// Kept apart from the MILO page so the sidebar can import it without pulling the page into the
// main bundle (the page itself is lazy-loaded).
// MILO shows pricing data for every account, so only the Admin and Super Admin roles may open it
// (sidebar link and page). Matched by role name: role ids differ per environment.
const MILO_ROLES = [USER_TYPES.ADMIN, USER_TYPES.SUPER_ADMIN]
export const canSeeMilo = (adminUser) => MILO_ROLES.includes(adminUser?.admin_role?.name?.trim().toLowerCase())
